import { render } from "./TradelawView.vue?vue&type=template&id=5b876632&scoped=true"
import script from "./TradelawView.vue?vue&type=script&lang=js"
export * from "./TradelawView.vue?vue&type=script&lang=js"

import "./TradelawView.vue?vue&type=style&index=0&id=5b876632&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b876632"]])

export default __exports__